import './Frame.scss';

import React from 'react';
import { Route } from 'react-router5';

import Footer from 'Components/Footer/Footer';
import Header from 'Components/Header/Header';


class Frame extends React.Component {
  render() {
    const { children, route } = this.props;
    return <div className="frame">
      <Header route={route} />
      <div className="frame__content">{children}</div>
      <Footer/>
    </div>;
  }
}

export default (props) => <Route>
  {({route}) => <Frame route={route} {...props} />}
</Route>;